export const getLawBases = (documentDate: Date | string | null | undefined): string[] => {
  const boundaryDate = new Date('2026-07-01');
  const date = documentDate ? new Date(documentDate) : new Date();
  if (date < boundaryDate) {
    return [
      "Căn cứ Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ.",
      "Căn cứ Nghị định 70/2025/NĐ-CP ngày 20/03/2025 của Chính phủ sửa đổi, bổ sung một số điều của Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ.",
      "Căn cứ Thông tư 32/2025/TT-BTC ngày 31/05/2025 của Bộ Tài chính hướng dẫn thực hiện Nghị định số 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ, Nghị định số 70/2025/NĐ-CP ngày 20/03/2025 sửa đổi, bổ sung một số điều Nghị định số 123/2020/NĐ-CP.",
      "Căn cứ vào thỏa thuận giữa các bên."
    ];
  } else {
    return [
      "Căn cứ Nghị định số 254/2026/NĐ-CP ngày 30/06/2026 của Chính phủ quy định chi tiết một số điều và biện pháp để tổ chức, hướng dẫn thi hành Luật Quản lý thuế số 108/2025/QH15 về hóa đơn điện tử, chứng từ điện tử.",
      "Căn cứ Thông tư số 91/2026/TT-BTC ngày 30/06/2026 của Bộ Tài chính quy định một số điều của Luật Quản lý thuế số 108/2025/QH15 và Nghị định số 254/2026/NĐ-CP của Chính phủ quy định chi tiết một số điều và biện pháp để tổ chức, hướng dẫn thi hành Luật Quản lý thuế về hóa đơn điện tử, chứng từ điện tử.",
      "Căn cứ vào thỏa thuận giữa các bên."
    ];
  }
};

export const getLawBasesText = (documentDate: Date | string | null | undefined): string => {
  const list = getLawBases(documentDate);
  return "\n" + list.map(item => `            - ${item}`).join("\n") + "\n            ";
};
